import { render, staticRenderFns } from "./BeginningChallengeContainer.vue?vue&type=template&id=6485a734&scoped=true&"
import script from "./BeginningChallengeContainer.vue?vue&type=script&lang=js&"
export * from "./BeginningChallengeContainer.vue?vue&type=script&lang=js&"
import style0 from "./BeginningChallengeContainer.vue?vue&type=style&index=0&id=6485a734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6485a734",
  null
  
)

export default component.exports